import { deserializeURLSearchParams, validateParams } from "@/lib/utils";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import z from "zod";

type Tab = { value: string };

export function useTabHandler({ options }: { options: Tab[] }) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const schema = z.object({
    t: z
      .string()
      .transform((value) => {
        return options.some((tab) => tab.value === value)
          ? value
          : options[0].value;
      })
      .default(options[0].value),
  });
  const { t: selectedTab } = validateParams(
    schema,
    deserializeURLSearchParams(searchParams.toString()),
  );

  const handleTabChange = (tabValue: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("t", tabValue);
    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  };

  return { selectedTab, handleTabChange };
}
